import { render } from "./TheMovies.vue?vue&type=template&id=0ce5725a&scoped=true"
import script from "./TheMovies.vue?vue&type=script&lang=js"
export * from "./TheMovies.vue?vue&type=script&lang=js"

import "./TheMovies.vue?vue&type=style&index=0&id=0ce5725a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce5725a"]])

export default __exports__